export enum Theme {
  V5DEFAULT = 'v5default',
}

export enum ThemeClass {
  v5default = 'vjs-theme-v5default',
}

export const DefaultTheme = Theme.V5DEFAULT;
